<template>
    <div class="guide-hub">
        <guideWelcome :hub="getHubData" />
        <div class="static-section">
            <div class="static-gs guide-col-2">
                <div>
                    <h2 class="f3 text-bold"><b>All about {{getHubData.hubName}}</b></h2>
                    <h2 class="f4">{{getHubData.hubName}} {{getHubData.subhubName}}</h2>
                </div>
                <div>
                  <mvtDropdownList :items="getNavigationData" label="Navigate" />
                </div>
            </div>
            <div class="static-gs guide-col-2">
                <div>
                    <guideArticleCard theme="large" :articles="guide.articles" />
                    <guidePaginate />
                    <div v-html="noResults"></div>
                </div>
                <div>
                    <div class="static-gs" v-if="officeData" >
                        <a class="link" :href="glb.appUrl + officeData.url">Movoto {{ officeData.displayName }} Office</a>
                    </div>
                    <guideHubSideContent v-if="getHubData.neighHubs" :hubItems="getHubData.neighHubs" :geo="guide.geo" contentType="Neighbourhood"/>
                    <guideHubSideContent v-if="getHubData.homesForSale" :hubItems="getHubData.homesForSale" :geo="guide.geo" contentType="HomesForSale"/>
                    <guideHubSideContent v-if="getHubData.postalCodeHubs" :hubItems="getHubData.postalCodeHubs" :geo="guide.geo" contentType="ZipCode"/>
                    <guideHubSideContent :geo="guide.geo" contentType="RealEstateLinks"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./guide-hub.js"></script>

<style lang="scss">
@use "./guide-hub.scss" as *;
</style>